import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { ProcessService } from '@services';
import { BehaviorSubject, } from 'rxjs';
import { finalize } from 'rxjs/operators';
var ProcessVersionsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ProcessVersionsModalComponent, _super);
    function ProcessVersionsModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this._fb = _this._injector.get(FormBuilder);
        _this._processService = _this._injector.get(ProcessService);
        return _this;
    }
    ProcessVersionsModalComponent.prototype.ngOnInit = function () {
        var appState = this._injector.get(AppStateFacade);
        this.isProcessEditAllowed$ = appState.user.permissions.isGranted('Processes.Edit');
        this.initialProcessVersion = this.context.data.processVersion;
        this.formGroup = this._fb.group({
            'arguments': [this.context.data.inputArguments || {}],
        });
    };
    ProcessVersionsModalComponent.prototype.onClose = function () {
        var closeResult = this.initialProcessVersion !==
            this.context.data.processVersion ?
            {
                type: 2 /* Update */,
                data: this.context.data,
            } :
            undefined;
        this._dialogRef.close(closeResult);
    };
    ProcessVersionsModalComponent.prototype.onUpdate = function (processList) {
        this.context.data = processList[0];
        this.formGroup.get('arguments')
            .patchValue(this.context.data.inputArguments || {});
    };
    ProcessVersionsModalComponent.prototype.updateParameters = function (inputArguments) {
        var _this = this;
        this.loading$.next(true);
        this._processService.patch(this.context.data.id, {
            inputArguments: inputArguments,
        }).pipe(finalize(function () { return _this.loading$.next(false); })).subscribe(function () {
            _this._dialogRef.close({
                type: 2 /* Update */,
                data: _this.context.data,
            });
        });
    };
    return ProcessVersionsModalComponent;
}(UiModalComponent));
export { ProcessVersionsModalComponent };
